import { render } from "./ChevronDoubleDownIcon.vue?vue&type=template&id=61409a9e"
import script from "./ChevronDoubleDownIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleDownIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__